import { render, staticRenderFns } from "./ColdCallScript.vue?vue&type=template&id=798cd597"
import script from "./ColdCallScript.vue?vue&type=script&lang=js"
export * from "./ColdCallScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports